import { useMemo } from "react"
import { NONE_VALUE } from "../JourneySelection"
import { Journeys } from "../../../types/Journeys"

export const assistantEnabledJourneys = ["PREGNANT"]
const assistantEnabledJourneyStages = ["PREGNANT_FIRST", "PREGNANT_SECOND", "PREGNANT_THIRD", "POSTPARTUM"]

type UseAssistantEnabledJourneyResult = {
  isSelectedJourneyAssistantEnabled: boolean
  isSelectedStageAssistantEnabled: boolean
}

export function useAssistantEnabledJourney(
  benefitEnabledJourneyData: Journeys | undefined,
  selectedPrimaryJourney: number | undefined,
  selectedPrimaryJourneyStage: number | undefined
): UseAssistantEnabledJourneyResult {
  return useMemo(() => {
    if (!benefitEnabledJourneyData || !selectedPrimaryJourney || selectedPrimaryJourney === NONE_VALUE) {
      return { isSelectedJourneyAssistantEnabled: false, isSelectedStageAssistantEnabled: false }
    }

    const journey = benefitEnabledJourneyData.find((j) => j.journeyId === selectedPrimaryJourney)
    if (!journey) {
      return { isSelectedJourneyAssistantEnabled: false, isSelectedStageAssistantEnabled: false }
    }

    const isJourneyEnabled = assistantEnabledJourneys.includes(journey.journeyEnumName)

    if (!selectedPrimaryJourneyStage || selectedPrimaryJourneyStage === NONE_VALUE) {
      return { isSelectedJourneyAssistantEnabled: isJourneyEnabled, isSelectedStageAssistantEnabled: false }
    }

    const journeyStage = journey.stages.find((s) => s.journeyStageId === selectedPrimaryJourneyStage)
    if (!journeyStage) {
      return { isSelectedJourneyAssistantEnabled: isJourneyEnabled, isSelectedStageAssistantEnabled: false }
    }

    const isStageEnabled = assistantEnabledJourneyStages.includes(journeyStage.journeyStageEnumName)

    return {
      isSelectedJourneyAssistantEnabled: isJourneyEnabled,
      isSelectedStageAssistantEnabled: isStageEnabled
    }
  }, [benefitEnabledJourneyData, selectedPrimaryJourney, selectedPrimaryJourneyStage])
}
